import React from 'react';
import { useSelector } from 'react-redux';
import { isBrowser } from 'ws-scripts/modules/environment';
import logger from 'ws-scripts/modules/logger';
import { ErrorBoundary } from 'wsm-error-boundary';
import { setNewRelicCustomAttribute } from '@ddc/new-relic';
import Form from '../components/Form';

const Widget = () => {
	const widgetInfo = useSelector((state) => state.widgetInfo);
	const { deviceType } = useSelector((state) => state.requestData);

	const { search } = widgetInfo;
	const isMobile = deviceType === 'MOBILE';

	// Server-side render emits a static, non-interactive placeholder; the live
	// interactive <Form /> is rendered on the client during hydration. The form
	// no longer depends on window.DDC.InvData being present at first render, so
	// it recovers regardless of widget mount order (see issue #128).
	if (!isBrowser) {
		const formClasses = 'form-control d-flex h-auto p-0';
		const formContent = (
			<form
				className={`free-text-search-form w-100 p-0 ${
					isMobile ? '' : formClasses
				} flex-column`}
			>
				<div className={isMobile ? formClasses : 'd-flex w-100'}>
					<input
						className={`free-text-search form-control form-control-transparent
							${isMobile ? 'font-size-ios-zoom-override' : 'input-lg'}`}
						id="free-text-search-input"
						type="search"
						name="search"
						placeholder="Search our inventory…"
						defaultValue={search ? decodeURIComponent(search) : ''}
					/>
					<span className="free-text-search-controls d-flex">
						<button
							className={`text-link px-4 mt-0 text-no-decoration icon-size-${
								isMobile ? 2 : 3
							} opacity-100 pointer-events-none`}
							type="submit"
							aria-disabled="true"
							title="Search"
							aria-label="Search"
						>
							<i
								id="search-icon"
								data-testid="search-icon"
								className="ddc-icon ddc-icon-search-sparkle input-decoration-color"
							/>
						</button>
					</span>
				</div>
			</form>
		);

		return isMobile ? (
			formContent
		) : (
			<div className="position-relative">{formContent}</div>
		);
	}

	return (
		<ErrorBoundary
			errorHandler={(error, errorInfo) => {
				setNewRelicCustomAttribute(
					'SRP ERROR',
					`ws-inv-text-search error boundary.\n${error}`
				);
				const newError = new Error(
					`ws-inv-text-search error boundary.\n${error}`
				);
				newError.originalError = error;
				newError.originalStackTrace = errorInfo.componentStack;
				logger.error(`${newError}\n${newError.originalStackTrace}`);
			}}
		>
			<Form />
		</ErrorBoundary>
	);
};

export default Widget;
